import { render, staticRenderFns } from "./CardActions.vue?vue&type=template&id=1a1fa812"
import script from "./CardActions.vue?vue&type=script&lang=js"
export * from "./CardActions.vue?vue&type=script&lang=js"
import style0 from "./CardActions.vue?vue&type=style&index=0&id=1a1fa812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports